import CartItem from './CartItem/CartItem.vue'
import {mapState} from 'vuex'
import productService from '../../services/product-service'
import Header from '../Header/Header.vue'
import Nav from '../Nav/Nav.vue'
import FormatService from '../../services/format-service'

export default {
    name: 'Cart',
    components: {
        CartItem,
        Header,
        Nav
    },
    data() {
        return {
            reference: "",
            commentary: "",
            shippingCosts: 0,
            currentErrorId: undefined
        }
    },
    methods: {
        checkout() {
            this.$store.dispatch('cart/sendOrder', {cartItems: this.cartItems, reference: this.reference, commentary: this.commentary, totalPrice: this.totalPrice})
            this.$gtag.event('place-order-click', {
                'event_category': 'order',
                'event_label': 'Place Order Button Clicked'
            })
        },

        removeDuplicates(myArr, prop) {
            return myArr.filter((obj, pos, arr) => {
                return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
            });
        }
    },
    computed: {
        ...mapState({
            cartItems: state => state.cart.items,
            user: state => state.account.user,
        }),
        totalPrice() {
            let price = 0;
            this.cartItems.forEach(element => {
                price += (productService.getCorrectPrice(element) * element.quantity)
            });
            this.shippingCosts = (price >= 150 || this.cartItems.length < 1) ? 0 : 7.50
            price += this.shippingCosts
            return price
        },
        currentProductGroups() {
            const allGroups = this.cartItems.map(item => item.product.product_group)            
            let unique = []
            allGroups.forEach(group => {
                if (!unique.map(group => group.id).includes(group.id)) unique.push(group)
            })
            return unique
        },
        wrongProductGroups() {
            var wrong = []
            this.currentProductGroups.forEach(group => {
                const itemsInGroup = this.cartItems.filter(cartItem => cartItem.product.product_group_id == group.id)
                var currentGroupQuantity = itemsInGroup.reduce((init, value) => parseInt(init) + value.quantity, 0)
                const wantedGroupQuantity = group.minimum_quantity_per_product_group
                if (!(currentGroupQuantity % wantedGroupQuantity == 0)) {
                    wrong.push({group: group, added: wantedGroupQuantity - (currentGroupQuantity % wantedGroupQuantity)})
                }
            })

            // Removing the current error id when group has no error
            if (this.currentErrorId && !wrong.map(item => item.group.id).includes(this.currentErrorId)) {
                this.currentErrorId = undefined
            }
            return wrong
        }
    },
    created() {
        if (!localStorage.signedIn) {
            this.$router.replace('/')
        }
        this.$store.dispatch('cart/retrieveShoppingBasket')
        this.$store.dispatch('account/getUser');
        this.$gtag.screenview({
            app_name: 'Retailers',
            screen_name: 'Cart',
        })
    },
    filters: {
        euro(value) {
            return FormatService.euro(value)
        }
    }
}